import {
  mobileConfig,
  PUSH_NOTIFICATIONS_DENIED,
  PUSH_NOTIFICATIONS_GRANTED,
  PUSH_NOTIFICATIONS_UNDETERMINED,
} from '../../commons/config';
import { useState } from 'react';
import { useInterval } from '../../hooks/useInterval';
import _ from 'lodash';

export type PushNotificationStatus =
  | typeof PUSH_NOTIFICATIONS_GRANTED
  | typeof PUSH_NOTIFICATIONS_UNDETERMINED
  | typeof PUSH_NOTIFICATIONS_DENIED;

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    pushNotificationStatus?: PushNotificationStatus;
    expoPushToken?: string | null;
  }
}

export type PushNotificationState = {
  status: PushNotificationStatus | null;
  expoPushToken: string | null;
};

export const usePushNotificationState = () => {
  const getCurrentState = () => {
    if (!mobileConfig().isMobile) return null;

    const currentStatus = window.pushNotificationStatus ?? null;
    const currentToken = window.expoPushToken ?? null;
    return currentStatus
      ? {
          status: currentStatus,
          expoPushToken: currentToken,
        }
      : null;
  };
  const [state, setState] = useState<PushNotificationState | null>(() => getCurrentState());

  useInterval(() => {
    const currentState = getCurrentState();
    if (!_.isEqual(currentState, state)) {
      setState(currentState);
    }
  }, 15_000);

  return { state };
};
